<template>
    <div class="container">
        <loader :active="loading" />

        <header class="jumbotron">
            <div class="info">
                <div class="info-head"><font-awesome-icon icon="user" />
                <h3> Profil <strong>{{ currentUser.clientNick }}</strong></h3></div>
                <small>Poniżej masz przedstawione informacje o sobie i Twojej strefie.</small>
            </div>
            <div class="profile-avatar">
                <progressive-img class="my-avatar" :src="'assets/avatars/' + currentUser.dbid + '.png'" fallback="assets/avatars/fallback.jpg"/>
            </div>
        </header>

        <table class="table table-bordered">
            <tr>
                <td colspan="2"><h5>Informacje o Tobie</h5></td>
            </tr>
            <tr>
                <td>DBID:</td>
                <td>{{ currentUser.clientDbid }}</td>
            </tr>
            <tr>
                <td>ID:</td>
                <td>{{ currentUser.clientId }}</td>
            </tr>
            <tr>
                <td>Unikalne id:</td>
                <td>{{ currentUser.clientUid }}</td>
            </tr>
            <tr>
                <td>Nick:</td>
                <td>{{ currentUser.clientNick }}</td>
            </tr>
            <tr>
                <td>Platforma:</td>
                <td>{{ currentUser.platform }}</td>
            </tr>
        </table>

        <table class="table table-bordered" v-if="premiumChannel">
            <tr>
                <td colspan="2"><h5>Informacje o Twojej strefie</h5></td>
            </tr>
            <tr>
                <td>ID kanału premium:</td>
                <td>{{ premiumChannel.id }}</td>
            </tr>
            <tr>
                <td>Nazwa strefy:</td>
                <td>{{ premiumChannel.zoneName }}</td>
            </tr>
            <tr>
                <td>ID grupy:</td>
                <td>{{ premiumChannel.groupId }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: 'Profile',
        data() {
            return {
                loading: true,
            };
        },
        computed: {
            currentUser() {
                return this.$store.state.auth.user;
            },
            premiumChannel() {
                return this.$store.state.auth.premiumChannel;
            }
        },
        mounted() {
            if (!this.currentUser) {
                this.$router.push({name: 'login'});
            }

            this.loading = false;
        }
    };
</script>

<style>
    .profile-avatar {
        width: 150px;
        height: 150px;
        margin-top: -50px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
    }

    .profile-avatar .my-avatar {
        -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
        -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
        box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
        margin-right: 6px;
    }
</style>